import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';

var _excluded = ["as", "aria-label", "className", "children", "color", "size"];
var Avatar = function Avatar(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'span' : _ref$as,
    ariaLabel = _ref['aria-label'],
    className = _ref.className,
    children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'default' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('Avatar', otherProps, color);
  var finalClasses = classnames('C-Avatar', _defineProperty(_defineProperty({}, "--size-".concat(size), size), "--color-".concat(color), color), className);
  if (!ariaLabel) {
    console.error("Hey Canvas User! Your Avatar needs an aria-label to tell screen readers what it represents.");
  }
  return /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses
  }, otherProps, {
    "aria-label": ariaLabel,
    role: "img"
  }), children);
};
Avatar.displayName = 'Avatar';

export { Avatar as default };
